import { queryPremiumRateForHBUDR as queryPremiumRate } from 'core/service/rider/query-premium-rate'
import { calculateRiderPremiumForHBUDR as calculateRiderPremium } from 'core/service/rider/premium-calculation'

export default {
  calculateRiderPremium,
  queryPremiumRate,
}
